import React from 'react';

import SelectMode from '../views/SelectMode';

import {
    Button, 
    Dialog, 
    DialogActions, 
    DialogContent, 
    DialogTitle,
    TextField,
    FormControlLabel,
    Checkbox
} from '@material-ui/core/';

import { SelectLanguage } from '@apricityhealth/web-common-lib/components/SelectLanguage';

export class SettingsDialog extends React.Component {
    constructor(props) {
        super(props);

        const appContext = props.appContext;
        const { updateInterval, mode, language, theme } = appContext.state;

        this.state = {
            updateInterval,
            mode,
            language,
            theme
        };
    }

    render() {
        const { state: { mode, language, updateInterval } } = this;
        return <Dialog open model='false' onClose={() => this.props.appContext.setState({ dialog: null })}>
            <DialogTitle>Settings</DialogTitle>
            <DialogContent>
                <SelectMode appContext={this} mode={mode} onChange={nMode => {
                    this.setState({ mode: nMode }); localStorage.setItem('mode', nMode);
                }} />
                <br />
                <SelectLanguage appContext={this} language={language} onChange={nLanguage => {
                    this.setState({ language: nLanguage }); localStorage.setItem('language', nLanguage);
                }} />
                <br />
                <FormControlLabel label='Disable Update Interval' control={<Checkbox checked={updateInterval <= 0} onChange={() => {
                    this.setState({ updateInterval: -updateInterval });
                }} />} />
                <br />
                {updateInterval > 0 && <TextField style={{ margin: 5 }} label={'Update Interval'} value={updateInterval} type='numeric' helperText='seconds' onChange={(v) => {
                    this.setState({ updateInterval: v.target.value });
                }} />}
            </DialogContent>
            <DialogActions>
                <Button variant='contained' style={{ margin: 5 }} onClick={this.onAppySettings.bind(this)}>Ok</Button>
            </DialogActions>
        </Dialog>;
    }

    onAppySettings() {
        const { appContext } = this.props;
        const { mode, theme, language } = this.state;
        let { updateInterval } = this.state;
        if (updateInterval < 30 && updateInterval > 0) {
            updateInterval = 30;        // don't let the update interval be more then every 30 seconds..
        }
        localStorage.setItem("language", language);
        localStorage.setItem("updateInterval", updateInterval);
        localStorage.setItem("mode", mode);

        appContext.setState({ updateInterval, mode, theme, language, dialog: null });
        appContext.handleMenuClose();
        if (updateInterval > 0)
            appContext.stores.DataTypesStore.startUpdates(updateInterval);
        else
            appContext.stores.DataTypesStore.stopUpdates();
    }
}

export default SettingsDialog;
